import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

// Get products
export const getProductReviewApi = createAsyncThunk("client/get-review-list", async (data, { rejectWithValue }) => {
  const token = localStorage.getItem("authToken");

  try {
    const response = await axios.post(`${baseUrl}serviceReviews/api/v1/getServiceReviewsList`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    console.log("product  re response", response);
    return response?.data; // ✅ Return only the data
  } catch (error) {
    console.error("Error fetching products r:", error);

    // ✅ Handle errors properly
    return rejectWithValue(error.response?.data?.message || "Failed to fetch products");
  }
});

// Update product review
export const updateProductReviewApi = createAsyncThunk("client/update-review", async (data, { rejectWithValue }) => {
  const token = localStorage.getItem("authToken");

  try {
    const response = await axios.put(`${baseUrl}serviceReviews/api/v1/updateServiceReviewsById/${data.rowId}`, data, {
      headers: {
        "auth-token": token,
        // "Content-Type": "application/json",
      },
      
    });
    console.log("product response", response);
    return response; // ✅ Return only the data
  } catch (error) {
    console.error("Error fetching products r:", error);

    // ✅ Handle errors properly
    return rejectWithValue(error.response?.data?.message || "Failed to fetch products");
  }
});

export const deleteProductReviewApi = createAsyncThunk("client/delete-review", async (ids, { rejectWithValue }) => {
  // const token = localStorage.getItem("authToken");
console.log("Deleting product reviews with IDs:", ids);
  try {
    const response = await axios.delete(`${baseUrl}serviceReviews/api/v1/bulkDeleteServiceReviews`,
     {
    data: {
      ids: [ids],
    },
    headers: {
      "Content-Type": "application/json",
    },
  });
    console.log("product response", response);
    return response; // ✅ Return only the data
  } catch (error) {
    console.error("Error fetching products r:", error);

    // ✅ Handle errors properly
    return rejectWithValue(error.response?.data?.message || "Failed to fetch products");
  }
});
//  get product count
export const getProductReviewCountApi = createAsyncThunk("client/countProductReview", async (data, { rejectWithValue }) => {
  const token = localStorage.getItem("authToken");

  try {
    const response = await axios.get(`${baseUrl}webapp/product-reviews/api/v1/countProductReview`, data, {
      headers: {
        "auth-token": token,
        "Content-Type": "application/json",
      },
    });
    console.log("product  re response", response);
    return response; // ✅ Return only the data
  } catch (error) {
    console.error("Error fetching products r:", error);

    // ✅ Handle errors properly
    return rejectWithValue(error.response?.data?.message || "Failed to fetch products");
  }
});
